module.exports = __webpack_public_path__ + "images/canonical-card/notification-icon.34d2bcee39a632187325.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/canonical-card/notification-icon.svg
// module id = 2YV4
// module chunks = 0